import React from "react";
import GridView from "src/SharedComponents/GridView/GridView";
import { IClinic, UserStatus } from "src/Utils/Hooks/useGetDistributorInfo/useGetDistributorInfo";
import './ClinicInfo.css'
import LogoText from "src/SharedComponents/LogoText/LogoText";
import ClinicManagement from "../ClinicManagement/ClinicManagement";
import { useTranslation } from "react-i18next";
import ClinicDevices from "../ClinicDevices/ClinicDevices";
import ClinicLicenses from "../ClinicLicenses/ClinicLicenses";
import { MailIcon, PhoneIcon, MapPinIcon, PersonIcon } from "src/SharedComponents/Icons/Icons";

interface IClinicInfoParams {
  clinic: IClinic;
  getClinicInfo: () => void;
  onClose: () => void;
}

const ClinicInfo: React.FC<IClinicInfoParams> = ({ clinic, getClinicInfo, onClose }) => {
  const { t } = useTranslation();
  const pendingText = clinic.distributorClinicAdminUserStatus === UserStatus.Invited ? `(${t('Pending')})` : '';
  return (
    <div>
      {/* Breadcrumb */}
      <nav aria-label="breadcrumb">
        <ol className="breadcrumb">
          <li className="breadcrumb-item"><span onClick={onClose} className="clickable-item">{t('Clinics')}</span></li>
          <li className="breadcrumb-item active" aria-current="page">{clinic.name}</li>
        </ol>
      </nav>
      {/* Used this css class in order to alter the css styles of gridview */}
      <div className="clinic-info" >
        <GridView title={clinic?.name} headerRightAlignedItem={<ClinicManagement clinic={clinic} getClinicInfo={getClinicInfo}/>}>
          <div className="d-flex flex-column">
            <LogoText logoElement={<PersonIcon />} text={clinic.distributorClinicAdminUserEmail} additionalText={pendingText} />
            <LogoText logoElement={<MailIcon />} text={clinic.email} />
            <LogoText logoElement={<PhoneIcon />} text={clinic.contactNumber} />
            <LogoText logoElement={<MapPinIcon />} text={clinic.address} />
          </div>
        </GridView>
      </div>
      <ClinicLicenses clinic={clinic} />
      <ClinicDevices
          clinic={clinic}
          updateDevices={getClinicInfo}
      />

    </div>
  );
};

export default ClinicInfo;
